import React from 'react';

import {AlertActions, AlertModal} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {PrepareModalContent} from '../PrepareModalContent';
import {PrepareModalProps} from './types';

const {agreementText} = translations['pt-br'].commons;
const {headerTitle} =
	translations['pt-br'].privateFlow.myAppointments.myAppointmentsList.examOrientations;

export function PrepareModal({open, setOpen, examNumber, examName}: PrepareModalProps) {
	return (
		<AlertModal
			customContentStyles={{
				alignItems: 'flex-start',
			}}
			showIcon={false}
			footerContent={
				<AlertActions
					primaryAction={() => setOpen(false)}
					primaryText={agreementText}
					flexDirection="column"
				/>
			}
			headerTitle={headerTitle}
			open={open}
			onClose={() => setOpen(false)}
			variant="primary"
			subDescription={<PrepareModalContent examNumber={examNumber} examName={examName} />}
		/>
	);
}
